import { Pcr } from '../../lib/types/models/pcr/pcr'
import { StaffApplicationPriorityInput } from '../../lib/types/models/staff-application/staff-application-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function changeStaffApplicationPriority(data: IdInput<StaffApplicationPriorityInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.candidate.changeApplicationPriority.url, { id }))
    .patch<Pcr, StaffApplicationPriorityInput>(rest)
}
